module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/cbee1376e77e8998d1ed4964e3c6d535.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_gem_5.svg
// module id = MQpP
// module chunks = 0